/* istanbul ignore file */
import React from 'react';
import { SystemTranslationKeys } from '@common/entities';

import { useSystemTranslation } from 'hooks';
import type { SubCharge } from 'types/shopping-cart';
import type { InstallmentChargeGroup } from 'utils/installment-charges';

import { ChargesAccordionSection } from './ChargesAccordionSection';
import { InstallmentsAccordionSection } from './InstallmentsAccordionSection';

interface Props {
  recurringCharges: SubCharge[];
  dueNow: SubCharge[];
  dueAtMoveIn: SubCharge[];
  installmentGroups: InstallmentChargeGroup[];
}

export function ChargesSection({
  recurringCharges,
  dueNow,
  dueAtMoveIn,
  installmentGroups,
}: Props) {
  const { tSystem } = useSystemTranslation();

  return (
    <>
      {dueNow.length > 0 && (
        <ChargesAccordionSection
          key="shopping_cart_duenow"
          title={tSystem(SystemTranslationKeys.payment.dueNow)}
          charges={dueNow}
        />
      )}
      {dueAtMoveIn.length > 0 && (
        <ChargesAccordionSection
          key="shopping_cart_dueatmovein"
          title={tSystem(SystemTranslationKeys.payment.dueAtMoveIn)}
          charges={dueAtMoveIn}
        />
      )}
      {recurringCharges.length > 0 && (
        <ChargesAccordionSection
          key="shopping_cart_recurring"
          title={tSystem(SystemTranslationKeys.payment.recurringCharges)}
          charges={recurringCharges}
          isRecurring
        />
      )}
      {installmentGroups.length > 0 && <InstallmentsAccordionSection groups={installmentGroups} />}
    </>
  );
}
